import { CAPABILITY_INTENT } from 'constants/config';
import { useRouter } from 'next/router';

export const useCapabilityIntent = () => {
  const router = useRouter();

  const currentCapability =
    router?.query?.ref_id === CAPABILITY_INTENT.PAYOUTS ? CAPABILITY_INTENT.PAYOUTS : CAPABILITY_INTENT.TREASURY;

  return { currentCapability };
};
